var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedInD(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LinkedIn"
  }, /*#__PURE__*/React.createElement("path", {
    id: "LinkedIn_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2617 4H5.80914C4.83086 4 4 4.77371 4 5.72686V26.272C4 27.2263 4.54514 28 5.52343 28H25.976C26.9554 28 28 27.2263 28 26.272V5.72686C28 4.77371 27.2411 4 26.2617 4ZM13.1429 13.1429H16.3737V14.7897H16.4091C16.9017 13.9017 18.3566 13 20.1554 13C23.608 13 24.5714 14.8331 24.5714 18.2286V24.5714H21.1429V18.8537C21.1429 17.3337 20.536 16 19.1166 16C17.3931 16 16.5714 17.1669 16.5714 19.0823V24.5714H13.1429V13.1429ZM7.42857 24.5714H10.8571V13.1429H7.42857V24.5714ZM11.2857 9.14286C11.2857 10.3269 10.3269 11.2857 9.14286 11.2857C7.95886 11.2857 7 10.3269 7 9.14286C7 7.95886 7.95886 7 9.14286 7C10.3269 7 11.2857 7.95886 11.2857 9.14286Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInD);
export default __webpack_public_path__ + "static/media/linkedIn_d.cebe347cbe87b5f3f47d3b8b790a469a.svg";
export { ForwardRef as ReactComponent };